export const EMPTY_HREF = '#';
